import React from 'react'
import AvatarComponent from '@Components/AvatarComponent'
import TagsBlock from '@Components/UserRowComponent/TagsBlock'
import { UserInfo } from '@Entities/user/user'

interface UserInfoBlockProps {
    userData: UserInfo
}

const UserInfoBlock = (props: UserInfoBlockProps) => {
    const { firstName, lastName, groups } = props.userData

    return (
        <div className="user-info">
            <AvatarComponent firstName={firstName} lastName={lastName} small />
            <div className="name-block">
                <h5 title={firstName + ' ' + lastName}>
                    {firstName} {lastName}
                </h5>
                <TagsBlock groups={groups} />
            </div>
        </div>
    )
}

export default UserInfoBlock
